package com.anjuros.website.redesign.sections.home

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.HomeWhyGridStyle
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

private val Reasons = listOf(
    RdText.HOME_WHY1_TITLE to RdText.HOME_WHY1_TEXT,
    RdText.HOME_WHY2_TITLE to RdText.HOME_WHY2_TEXT,
    RdText.HOME_WHY3_TITLE to RdText.HOME_WHY3_TEXT,
    RdText.HOME_WHY4_TITLE to RdText.HOME_WHY4_TEXT,
    RdText.HOME_WHY5_TITLE to RdText.HOME_WHY5_TEXT,
)

@Composable
fun HomeWhySection() {
    RdSection(id = "why", labelledBy = "why-h") {
        RdSectionHead(RdText.HOME_WHY_EYEBROW, "why-h", RdText.HOME_WHY_TITLE)
        Div(HomeWhyGridStyle.toModifier().toAttrs()) {
            Reasons.forEach { (title, text) ->
                Div {
                    H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(title)) }
                    P { Text(LocalText(text)) }
                }
            }
            Div {
                H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(RdText.HOME_WHY6_TITLE)) }
                P {
                    Text(LocalText(RdText.HOME_WHY6_TEXT))
                    RdLink(RdRoute.ABOUT) { Text(LocalText(RdText.HOME_WHY6_LINK)) }
                }
            }
        }
    }
}
